import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteOtrosFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='OTROS' htmlFor='input-importeOtros' md={12} />
      <Col md={12}>
        <Form.InputNumber
          id='input-importeOtros'
          name='input-importeOtros'
          value={iValue}
          disabled
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteOtrosFormGroup)
